import script from "./TheResultWithError.vue?vue&type=script&setup=true&lang=js"
export * from "./TheResultWithError.vue?vue&type=script&setup=true&lang=js"

import "./TheResultWithError.vue?vue&type=style&index=0&id=f10331be&scoped=true&lang=css"

import exportComponent from "/home/sergey/projects/tm/calc_furnace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f10331be"]])

export default __exports__